import authFetch from './fetch';
import { getQueryParams, makeRequest } from './utils';

export const getOrganizationFuelTariffsGrid = (params) => makeRequest(authFetch.get(`/api/OrganizationsFuelTariffs${getQueryParams(params)}`));

export const getOrganizationFuelTariffsAudits = (id, params) => makeRequest(
  authFetch.get(`/api/OrganizationsFuelTariffs/${id}/Audits${getQueryParams(params)}`),
);

export const getOrganizationFuelTariffsAuditProperties = (id) => makeRequest(
  authFetch.get(`/api/OrganizationsFuelTariffs/${id}/Audits/Properties`),
);

export const getOrganizationFuelTariffsAuditUsers = (id) => makeRequest(
  authFetch.get(`/api/OrganizationsFuelTariffs/${id}/Audits/Users`),
);

export const deleteOrganizationFuelTariff = (id) => makeRequest(authFetch.delete(`/api/OrganizationsFuelTariffs/${id}`));
export const restoreOrganizationFuelTariff = (id) => makeRequest(authFetch.patch(`/api/OrganizationsFuelTariffs/${id}`));
export const upsertOrganizationFuelTariff = (fuelTariff) => makeRequest(authFetch.put('/api/OrganizationsFuelTariffs/', fuelTariff));
export const getOrganizationFuelTariff = (id) => makeRequest(authFetch.get(`/api/OrganizationsFuelTariffs/${id}`));
export const getOrganizationFuelTariffEntries = (id, date) => makeRequest(authFetch.get(`/api/OrganizationsFuelTariffs/${id}/entries${getQueryParams({ date, pageSize: 150, page: 1 })}`));
export const getOrganizationFuelTariffDates = (id) => makeRequest(authFetch.get(`/api/OrganizationsFuelTariffs/${id}/dates`));
export const upsertOrganizationFuelTariffEntry = (tariffId, entry) => makeRequest(authFetch.put(`/api/OrganizationsFuelTariffs/${tariffId}/entries`, entry));
export const deleteOrganizationFuelTariffEntry = (tariffId, entryId) => makeRequest(authFetch.delete(`/api/OrganizationsFuelTariffs/${tariffId}/entries/${entryId}`));
